module.exports = __webpack_public_path__ + "img/spinner.abfb181f.gif";